import React from 'react'
import '../CSS/style.css'
import '../CSS/responsive.css'
import cprogram from  '../assets/icons_programming/c_programming_512x512.png'
import cppprogram from  '../assets/icons_programming/cpp_programming_512x512.png'
import javaprogram from  '../assets/icons_programming/java_programming_512x512.png'
import pythonprogram from  '../assets/icons_programming/python_programming_512x512.png'
import { Link } from 'react-router-dom'

export default function Works() {
    // document.title = "Codes - UnlockCode"
  return (
    <>
    <br />
        <div className="p-heading">Programs</div>
        <div className="languages flex">

            <div className="c flex fd-col">
                <img className='progImg' src={cprogram} alt="C Programming" />
                <Link to="/cprograms"><button className='submitbtn'>C Programs</button></Link>
            </div>    
            <div className="c flex fd-col">
                <img className='progImg' src={cppprogram} alt="C++ Programming" />
                <Link to="/c++programs"><button className='submitbtn'>C++ Programs</button></Link>
            </div>    
            <div className="c flex fd-col">
                <img className='progImg' src={javaprogram} alt="Java Programming" />
                <Link to="/java_programs"><button className='submitbtn'>Java Programs</button></Link>
            </div>    
            <div className="c flex fd-col">
                <img className='progImg' src={pythonprogram} alt="Python Programming" />
                <Link to="/python_programs"><button className='submitbtn'>Python Programs</button></Link>
            </div>    
        </div>   
        <br />     
    </>
  )
}
